//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { ProductCardCategoryModel } from '../Models/MpCard/ProductCardCategoryModel';
import { IntegrationType } from '../Entity/IntegrationType';
import { CategoryAttributeModel } from '../Models/MpCard/CategoryAttributeModel';

import { boundClass } from 'autobind-decorator';
import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios';
import { encodeUrlParameter, getAxiosData } from '../../../common/urlUtility';
@boundClass export class ProductCategoryController
{
  constructor (axios: AxiosInstance)
  {
    this.axios = axios
  }
  
  private readonly axios: AxiosInstance
  
  getCategories(integration: IntegrationType, stringForSearch: string, _config?: AxiosRequestConfig) : Promise<ProductCardCategoryModel[]>
  {
    return this.axios.get<ProductCardCategoryModel[]>(`ProductCategory/GetCategories/${encodeUrlParameter(integration)}?stringForSearch=${encodeUrlParameter(stringForSearch)}`, _config).then(getAxiosData)
  }
  

  getBaseAttributes(_config?: AxiosRequestConfig) : Promise<CategoryAttributeModel[]>
  {
    return this.axios.get<CategoryAttributeModel[]>(`ProductCategory/GetBaseAttributes`, _config).then(getAxiosData)
  }
  

  getCategoryAttributes(categoryId: string, _config?: AxiosRequestConfig) : Promise<CategoryAttributeModel[]>
  {
    return this.axios.get<CategoryAttributeModel[]>(`ProductCategory/GetCategoryAttributes?categoryId=${encodeUrlParameter(categoryId)}`, _config).then(getAxiosData)
  }
  

  /** Gets the full relative URL for the action */
  getCategoriesUrl(integration: IntegrationType, stringForSearch: string, _config?: AxiosRequestConfig) : string
  {
    return `/api/ProductCategory/GetCategories/${encodeUrlParameter(integration)}?stringForSearch=${encodeUrlParameter(stringForSearch)}`
  }
  

  /** Gets the full relative URL for the action */
  getBaseAttributesUrl(_config?: AxiosRequestConfig) : string
  {
    return `/api/ProductCategory/GetBaseAttributes`
  }
  

  /** Gets the full relative URL for the action */
  getCategoryAttributesUrl(categoryId: string, _config?: AxiosRequestConfig) : string
  {
    return `/api/ProductCategory/GetCategoryAttributes?categoryId=${encodeUrlParameter(categoryId)}`
  }
  

}
